const formatAdjustments = adjustments =>
  (adjustments ?? []).reduce(
    (adjustmentsAcc, adjustment) => [
      ...adjustmentsAcc,
      {
        id: adjustment.reference,
        reference: adjustment.reference,
        description: adjustment.description,
        type: adjustment.is_percentage ? 'percentage' : 'amount',
        amount: adjustment.amount,
        is_discount: adjustment.is_discount,
        is_percentage: adjustment.is_percentage,
        result: adjustment.result,
      },
    ],
    [],
  );

export default formatAdjustments;
